<template>
    <modal name="quiz-notification-modal" width="100%" :max-width="446" :adaptive="true" :scrollable="true">
        <div class="quiz-notification-modal">
            <span v-html="$t('Quiz.content_blocked_title')" class="quiz-notification-modal__title"></span>
            <span class="quiz-notification-modal__description" v-html="$t('Quiz.content_blocked_paragraph')"></span>
            <TotemButton
                class="quiz-notification-modal__take-quiz-button"
                size="medium"
                color="primary"
                @click="takeTheLastQuiz"
                :label="$t('Quiz.take_the_quiz')"
            />
            <TotemButton
                class="quiz-notification-modal__close"
                size="medium"
                color="primary"
                @click="closeModal"
                :label="$t('General.close')"
            />
        </div>
    </modal>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
    name: 'quiz-notification-modal',
    methods: {
        closeModal () {
            this.$modal.hide('quiz-notification-modal')
        },
        takeTheLastQuiz () {
            const lastMicrotest = this.findLastMicrotestBeforeDisabledCourses(this.microLearningSections, this.getLastClickedMicroLearningSection.elementId)
            this.$store.dispatch('MicroLearning/assignMicroLearningSection', lastMicrotest)
            this.$modal.hide('quiz-notification-modal')
        },
        findLastMicrotestBeforeDisabledCourses(array, clickedElementId) {
            const clickedIndex = array.findIndex(el => el.elementId === clickedElementId)
            if (clickedIndex === -1) return null

            let i = clickedIndex

            // Step 1: If clicked element is in a disabled block, move back until we exit that block
            while (i >= 0 && array[i].disabledByMicrotest) {
                i--
            }

            // Step 2: Now search backward for the closest microtest
            for (; i >= 0; i--) {
                const item = array[i]
                if (item.type === "microtest") {
                    return item
                }
            }

            return null
        }
    },
    computed: {
        ...mapGetters({
            currentMicroLearningSection: 'MicroLearning/getMicroLearningSection',
            microLearningSections: 'MicroLearning/getMicroLearningSections',
            getLastClickedMicroLearningSection: 'Quiz/getLastClickedMicroLearningSection'
        })

    }
}
</script>
<style lang="scss" scoped>
.quiz-notification-modal {
    border: 0;
    border-radius: 10px 10px 0 0;
    font-family: PPAgrandir-Medium, sans-serif;
    font-size: 1.8rem;
    padding: 20px;
    width: 100%;
    flex-direction: column;
    display: flex;
    text-align: center;
    gap: 30px;

    &__take-quiz-button {
        font-size: 2.4rem;
        cursor: pointer;
    }
    
    &__description {
        font-family: PlusJakartaSans-Regular, sans-serif;
        font-size: 1.6rem;
        color: $tuatara;
    }

    &__title {
        font-size: 1.8rem;
        line-height: 130%;

        [class*="desktop"] & {
            font-size: 2.2rem;
        }
    }
}
</style>
